import { choose, iff, when } from '@digibee/control-statements';
import { Button } from '@heroui/react';
import { Plus } from 'iconoir-react';
import { head } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import * as Elements from './Action.elements';

import i18n from '~/common/helpers/i18n';
import Menu from '~/components/Menu';
import Role from '~/components/Role';
import TextNative from '~/components/Text';

const Container = styled.div``;

const Action = ({ configActionButton }) => {
  if (!configActionButton || configActionButton.length === 0) return null;

  const configActions =
    configActionButton?.length === 1
      ? head(configActionButton)
      : configActionButton;

  return (
    <Container>
      {choose(
        when(configActions?.action, () => (
          <Button
            startContent={<Plus className='icon-smallest' />}
            onPress={configActions.action}
            data-testid={configActions['data-testid']}
            radius='full'
            color='secondary'
          >
            {i18n.t('scenes.beta.actions.create')}
          </Button>
        )),
        when(!configActions?.hidden && !configActions?.action, () => (
          <Menu
            left='-105px'
            component={({ toggle }) => (
              <Button
                startContent={<Plus className='icon-small' />}
                onPress={toggle}
                color='secondary'
                radius='full'
                data-testid={
                  configActions['data-testid'] || 'build-button-container'
                }
              >
                {i18n.t('scenes.beta.actions.create')}
              </Button>
            )}
          >
            <Elements.List inset noHairlines>
              {configActionButton?.map(item =>
                iff(!item.hidden, () => (
                  <Role name={item.role}>
                    <Elements.Item
                      onClick={item.action}
                      data-testid={item['data-testid']}
                    >
                      <div className='flex items-center gap-2'>
                        {item.icon && typeof item.icon === 'function' && (
                          <item.icon className='icon-smallest' />
                        )}
                        <TextNative as='span' align='left'>
                          {item.text}
                        </TextNative>
                        {iff(item.badge, () => (
                          <Elements.Badge
                            type='primary'
                            data-testid='build-badge'
                          >
                            {item.badge}
                          </Elements.Badge>
                        ))}
                      </div>
                    </Elements.Item>
                  </Role>
                ))
              )}
            </Elements.List>
          </Menu>
        ))
      )}
    </Container>
  );
};

Action.defaultProps = {
  configActionButton: undefined
};

Action.propTypes = {
  configActionButton: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.func,
      text: PropTypes.string,
      icon: PropTypes.elementType
    })
  )
};

export default Action;
